<template>
    <div v-if="aula !== undefined" @click.self="$router.push(`/aula/${aula.id}`)" class="cursor-pointer max-w-sm group relative">
        <div v-if="aula.thumbnail_url !== null || aula.thumbnail_url !== ''" class="w-full relative h-56 bg-gray-300 bg-center bg-cover transition group-hover:grayscale-[50%] border border-gray-200" :style="{ 'background-image': aula.thumbnail_url ? `url('${aula.thumbnail_url}')` : '' }">
            <span class="absolute bottom-1.5 right-1 text-[10px] text-white bg-black rounded-sm px-1">
                {{ aula.time }}
            </span>
            <div class="flex items-center justify-center w-full h-56">
                <div class="group-hover:scale-110 group-hover:bg-gray-400/70 bg-gray-400/50 px-4 py-2 flex items-center justify-center rounded">
                    <svg class="w-5 h-5 text-gray-200" fill="currentColor" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg"><path d="M175 .024V1920l1570.845-959.927z" fill-rule="evenodd"/></svg>
                </div>
            </div>
            <div v-if="aula.assistiu == true" class="relative -mt-[4.2px] flex bg-[#909090]">
                <div class="progress-bar" role="progressbar" style="background-color: #ff0000; height: 4px; width: 100%"></div>
            </div>
            <div class="relative -mt-[4.2px] flex bg-[#c5bfb6]" v-html="gerarDadosProgresso(aula)"></div>
        </div>
        <!-- <div class="w-full h-12">
            <div class="flex flex-col space-y-2 pt-3 px-2 w-full h-full">
                <h3 class="text-sm sm:font-medium text-gray-700 text-left dark:text-gray-100">{{aula.nome}}</h3>
            </div>
        </div> -->
    </div>
</template>
<script>
    import { mapGetters, mapMutations } from 'vuex'
    export default {
        name: 'SingleVideoComponent',
        props: {
            aula: {
                type: Object,
                required: false
            }
        },
        methods: {
            ...mapMutations(['ADD_TO_CART']),
            gerarDadosProgresso(aula) {
                if(aula == undefined || !aula.duration || aula.intervalos == undefined ) return;
                const duration = aula.duration;
                const periodos = aula.intervalos;
                let dados_progress_mult = '';
                
                if (periodos[0].inicio !== 0) {
                    dados_progress_mult += '<div class="progress-bar" role="progressbar" style="width: ' +
                    (periodos[0].inicio / duration) * 100 +
                    '%; background-color: #c5bfb6;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>';
                }
                periodos.forEach((periodo, index) => {
                    dados_progress_mult += '<div class="progress-bar" role="progressbar" style="background-color: #ff0000; height: 5px; width: ' +
                        ((periodo.fim - periodo.inicio) / duration) * 100 + '%"></div>';

                    if (index < periodos.length - 1) {
                        const proximoPeriodo = periodos[index + 1];
                        if (periodo.fim < duration) {
                            dados_progress_mult += '<div class="progress-bar" role="progressbar" style="width: ' +
                            ((proximoPeriodo.inicio - periodo.fim) / duration) * 100 + '%; background-color: #c5bfb6;"></div>';
                        }
                    }
                });

                return dados_progress_mult;
            },
        },
        computed:{
            ...mapGetters(['getAulasAssistidas']),
        }
    }
</script>